/* ============================================================================
   Motion demos index
   The library of single-pattern experiments. Same entry choreography as the
   lab homepage — intro copy, then cards — minus the Vocabulary playground.
   ========================================================================= */

import { initMotion, isReduced, MOTION } from './motion.js';
import { mountLabBar } from './lab.js';

const { gsap } = initMotion();
mountLabBar({ title: 'Motion demos' });

function build() {
  const intro = gsap.utils.toArray('[data-intro]');
  const cards = gsap.utils.toArray('[data-exp]');

  if (isReduced()) {
    gsap.set([...intro, ...cards], { opacity: 1, y: 0, clearProps: 'transform' });
    return;
  }

  gsap.set(intro, { opacity: 0, y: MOTION.rise.sm });
  gsap.set(cards, { opacity: 0, y: MOTION.rise.md });

  gsap
    .timeline()
    .to(intro, { opacity: 1, y: 0, duration: MOTION.dur.slow, stagger: MOTION.stagger.base })
    .to(
      cards,
      { opacity: 1, y: 0, duration: MOTION.dur.slow, stagger: MOTION.stagger.base },
      '-=0.4'
    );
}

build();
window.addEventListener('mo:replay', build);
